import DataTable from "react-data-table-component";
import { Card, CardBody, Col } from "reactstrap";
import RowCreateCallbackHeadrer from "./RowCreateCallbackHeadrer";
import { ROW_CREAT_CALL_COLUMN, ROW_CREAT_CALL_DATA } from "../../../../Data/DataTable/RowCreateCallbackData";

const RowCreateCallback = () => {
  return (
    <Col sm="12">
      <Card>
        <RowCreateCallbackHeadrer/>
        <CardBody>
          <div className="table-responsive theme-scrollbar" id="row_create">
            <DataTable data={ROW_CREAT_CALL_DATA} columns={ROW_CREAT_CALL_COLUMN} highlightOnHover striped pagination className="display dataTable"/>
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default RowCreateCallback;
